<template>
	<div v-loading.fullscreen.lock="visible.loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 门禁报表</el-breadcrumb-item>
				<el-breadcrumb-item>申请记录报表</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="container" v-if="power.search">
			<div class="handle-box left">
				<el-radio-group v-model="data.histype" size="small" class="left mr10">
					<el-radio-button :label="1">当前可办</el-radio-button>
					<el-radio-button :label="2">历史记录</el-radio-button>
				</el-radio-group>
				<el-checkbox-group v-model="data.timetype" size="small" class="left mr10" @change="handleChangeTimeType">
					<el-checkbox-button :label="1">申请时间</el-checkbox-button>
					<el-checkbox-button :label="2">有效期</el-checkbox-button>
				</el-checkbox-group>
				<el-date-picker v-model="data.daterange" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" size="large" class="left mr10" style="width:500px" start-placeholder="开始时间" end-placeholder="结束时间" v-if="data.timetype.length == 1">
				</el-date-picker>
				<el-input v-model="data.filterstr" placeholder="人员姓名/身份证/车牌号" class="left mr10" size="large" style="width:260px" clearable></el-input>
				<el-input v-model="data.deptname" placeholder="引进部门" class="left mr10" size="large" style="width:260px" clearable></el-input>
				<el-input v-model="data.mobile" placeholder="联系电话" class="left mr10" size="large" style="width:260px" clearable 
					v-if="data.emptype != 100 && data.emptype != 101"></el-input>
				<el-radio-group v-model="data.type" size="small" class="left mr10" @change="handleChangeType">
					<el-radio-button :label="1">长期</el-radio-button>
					<el-radio-button :label="2">临时</el-radio-button>
				</el-radio-group>
				<el-radio-group v-model="data.emptype" size="small" class="left mr10" @change="handleChangeEmpType">
					<el-radio-button v-for="(item,index) in data.emptypes" :key="item.value" :label="item.value">{{item.label}}</el-radio-button>
				</el-radio-group>
				<el-radio-group v-model="data.doorpost" size="small" class="left mr10">
					<el-radio-button v-for="(item,index) in data.doorposts" :key="item.value" :label="item.value">{{item.label}}</el-radio-button>
				</el-radio-group>
				<el-button type="primary" icon="el-icon-search" size="small" class="left mr10" @click="search" v-if="power.search">搜索</el-button>
			</div>
			<div class="handle-box right">
				<el-button type="primary" @click="toExport" v-if="power.export">
					<i class="if-lcon-daoru"></i>导出
				</el-button>
				<el-button type="primary" @click="toPrint" class="mr10" v-if="power.print">
					<i class="if-lcon-dayin"></i>打印
				</el-button>
			</div>
			<el-table id="applyRecordReportTable" ref="table" :data="data.rows" border class="table" height="570">
				<el-table-column prop="code" :label="(data.emptype >= 100 ? '车辆' : '人员')+'编号'" width="120">
				</el-table-column>
				<el-table-column prop="idno" label="身份证" width="230">
					<template slot-scope="scope">
						<el-button type="text" size="small" v-if="data.type == 1" disabled>{{scope.row.idno}}</el-button>
						<el-button @click="showVisitDetail(scope.row)" type="text" size="small" title="点击查看临时卡办理历史" v-else>{{scope.row.idno}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="姓名/车牌号" width="130">
				</el-table-column>
				<el-table-column prop="deptName" label="引进部门" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="mobilePhone" label="联系电话" width="130">
				</el-table-column>
				<el-table-column prop="groupName" label="授权点" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="applyTime" label="申请时间" width="215">
				</el-table-column>
				<el-table-column prop="valid" label="有效期" width="435">
					<template slot-scope="scope">
						{{ scope.row.validStart }} 至 {{ scope.row.validEnd }}
					</template>
				</el-table-column>
				<el-table-column prop="lastTime" label="最后办理时间" width="215">
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentPageChange"
					:current-page="data.page" :page-sizes="[10,14,20,50,100,200,300,400,500]"
					:page-size="data.size" layout="total, sizes, prev, pager, next, jumper" :total="data.total">
				</el-pagination>
			</div>
		</div>
	
		<el-dialog :title="data.curIdno + ' - 临时卡办理历史'" :visible.sync="visible.detail" :close-on-click-modal="false" width="1600px">
			<el-table id="applyRecordReportDetailTable" ref="detailtable" :data="data.details" border class="table" height="600">
				<el-table-column prop="type" label="类别" width="70">
					<template slot-scope="scope">
						<el-tag type="info" v-if="scope.row.type == 1">人员</el-tag>
						<el-tag type="info" v-else-if="scope.row.type == 2">车辆</el-tag>
						<el-tag type="info" v-else>-</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="deptName" label="引进部门" width="300" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="idno" label="身份证" width="230">
				</el-table-column>
				<el-table-column prop="name" label="姓名/车牌号" width="130">
				</el-table-column>
				<el-table-column prop="doorPostName" label="办理门岗" width="130">
				</el-table-column>
				<el-table-column prop="mobilePhone" label="联系电话" width="130">
				</el-table-column>
				<el-table-column prop="groupName" label="授权点" width="200" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="visitTime" label="办理时间" width="210">
				</el-table-column>
				<el-table-column prop="backTime" label="退卡时间" width="210">
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
	import printJS from 'print-js';
	export default {
		name: 'applyrecordreport',
		data() {
			return {
				data: {
					filterstr: '',
					deptname: '',
					mobile: '',
					daterange: [],
					rows: [],
					total: 0,
					size: 14,
					page: 1,
					histype: 1,
					timetype: [],
					type: 2,
					emptype: 9,
					doorpost: 8,
					emptypes: [
						{value:9,label:'临时人员'},
						{value:101,label:'临时车辆'}
					],
					doorposts: [
						{value:8,label:'1#门岗'},
						{value:9,label:'2#门岗'},
						{value:10,label:'6#门岗'},
						{value:41,label:'7#门岗'}
					],
					details: [],
					curIdno: '',
				},
				visible: {
					detail: false,
					print: false,
					loading: false
				},
				power: {
					pageId: 74,
					search: false,
					export: false,
					print: false
				}
			}
		},
		methods: {
			search(change) {
				let ths = this;
				ths.visible.loading = true;
				if (change) {
					ths.data.page = 1;
				}
				let whereStr = '';
				if (ths.data.timetype.length == 1) {
					whereStr = '&starttime=' + ths.data.daterange[0] + '&endtime=' + ths.data.daterange[1] + '&timetype=' + ths.data.timetype[0];
				} else {
					whereStr = '&timetype=0';
				}
				let query = '?sign=' + window.$gloable.userinfo.sign + '&type=' + ths.data.type + '&emptype=' + ths.data.emptype + 
					'&doorpost=' + ths.data.doorpost + '&histype=' + ths.data.histype + '&pagesize=' + ths.data.size + 
					'&currentpage=' + ths.data.page + '&deptname=' + ths.data.deptname + '&mobile=' + ths.data.mobile + 
					'&filterstr=' + ths.data.filterstr + whereStr;
				window.ax.get('api/report/acs/applyrecordlist' + query, {}).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						data = data.data;
						let len = data.datas.length;
						let total = data.totalRecord;
						ths.data.rows = data.datas;
						ths.data.total = total;
						if (len == 0 && total > 0) {
							ths.data.page = Math.ceil(total / ths.data.size);
							ths.search();
						}
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					console.log(err);
					ths.visible.loading = false;
				});
			},
			handleSizeChange(size) {
				this.data.size = size;
				this.data.page = 1;
				this.search();
			},
			handleCurrentPageChange(current) {
				this.data.page = current;
				this.search();
			},
			showVisitDetail(r) {
				let ths = this;
				ths.visible.loading = true;
				ths.data.curIdno = r.idno;
				let opt = {
					sign: window.$gloable.userinfo.sign,
					idno: r.idno
				};
				let query = '?sign=' + window.$gloable.userinfo.sign + '&idno=' + r.idno;
				window.ax.get('api/report/acs/applyvisitdetaillist' + query, {}).then(rsp => {
					let data = rsp.data;
					ths.visible.loading = false;
					if (data.code == 1) {
						if (data.data.length > 0) {
							ths.data.details = data.data;
							ths.visible.detail = true;
						} else {
							ths.$message.success('无临时卡办理历史');
						}
					} else {
						ths.$message.error(data.message);
					}
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					console.log(err);
					ths.visible.loading = false;
				});
			},
			handleChangeTimeType(val) {
				if (val.length > 1) {
					this.data.timetype = [val[1]];
				}
			},
			handleChangeType(val) {
				let ths = this;
				if (val == 1) {
					ths.data.timetype = [1];
					ths.data.emptypes = [
						{value:1,label:'员工'},
						{value:2,label:'保运'},
						{value:4,label:'外协'},
						{value:100,label:'长期车辆'}
					];
					ths.data.emptype = 	4;
					
					ths.data.doorposts = [{value:15,label:'1#门岗'},{value:16,label:'2#门岗'},{value:17,label:'6#门岗'},{value:43,label:'7#门岗'},{value:23,label:'1号办公楼'},{value:24,label:'中控室'}];
					ths.data.doorpost = 15;
				} else if (val == 2) {
					ths.data.timetype = [];
					ths.data.emptypes = [
						{value:9,label:'临时人员'},
						{value:101,label:'临时车辆'}
					];
					ths.data.emptype = 	9;
					
					ths.data.doorposts = [{value:8,label:'1#门岗'},{value:9,label:'2#门岗'},{value:10,label:'6#门岗'},{value:41,label:'7#门岗'}];
					ths.data.doorpost = 8;
				}
			},
			handleChangeEmpType(val) {
				let ths = this;
				if (ths.data.type == 1) {
					if (ths.data.emptype == 1 || ths.data.emptype == 2 || ths.data.emptype == 4) {
						//长期人员
						ths.data.doorposts = [{value:15,label:'1#门岗'},{value:16,label:'2#门岗'},{value:17,label:'6#门岗'},{value:43,label:'7#门岗'},{value:23,label:'1号办公楼'},{value:24,label:'中控室'}];
						ths.data.doorpost = 15;
					} else if (ths.data.emptype == 100) {
						//长期车辆
						ths.data.doorposts = [{value:18,label:'1#门岗'},{value:19,label:'2#门岗'},{value:20,label:'6#门岗'},{value:44,label:'7#门岗'}];
						ths.data.doorpost = 18;
					}
				} else if (ths.data.type == 2) {
					if (ths.data.emptype == 9) {
						//临时人员
						ths.data.doorposts = [{value:8,label:'1#门岗'},{value:9,label:'2#门岗'},{value:10,label:'6#门岗'},{value:41,label:'7#门岗'}];
						ths.data.doorpost = 8;
					} else if (ths.data.emptype == 101) {
						//临时车辆
						ths.data.doorposts = [{value:12,label:'1#门岗'},{value:13,label:'2#门岗'},{value:14,label:'6#门岗'},{value:42,label:'7#门岗'}];
						ths.data.doorpost = 12;
					}
				}
			},
			toExport() {
				let ths = this;
				let where = '';
				for (let i = 0; i < ths.data.type.length; i++) {
					where += ('&type=' + ths.data.type[i]);
				}
				where += ('&addrType=' + ths.data.addrType);
				for (let i = 0; i < ths.data.refund.length; i++) {
					where += ('&refund=' + ths.data.refund[i]);
				}
				window.open('api/report/pos/exportsendmeal1list?date=' + ths.data.date + where + '&sign=' + window.$gloable.userinfo.sign, '_blank');
			},
			toPrint() {
				let printTarget = document.getElementById('printDOMElement');
				if (printTarget) {
					printTarget.remove();
				}
				let ths = this;
				let html = document.querySelector('#sendMeal1ReportTable').innerHTML;
				// 新建一个 DOM
				const div = document.createElement('div');
				const printDOMID = 'printDOMElement';
				div.id = printDOMID
				div.innerHTML = html;

				// 提取第一个表格的内容 即表头
				const th = div.querySelectorAll('.el-table__header-wrapper th');
				const ThsTextArry = [];
				for (let i = 0, len = th.length; i < len; i++) {
					if (th[i].innerText !== '') ThsTextArry.push(th[i].innerText);
				}

				// 删除多余的表头
				div.querySelector('.hidden-columns').remove();
				// 第一个表格的内容提取出来后已经没用了 删掉
				div.querySelector('.el-table__header-wrapper').remove();

				// 将第一个表格的内容插入到第二个表格
				let newHTML = '<tr>';
				for (let i = 0, len = ThsTextArry.length; i < len; i++) {
					newHTML += '<td style="text-align: left; font-weight: bold">' + ThsTextArry[i] + '</td>';
				}

				newHTML += '</tr>';
				div.querySelector('.el-table__body-wrapper table').insertAdjacentHTML('afterbegin', newHTML);
				// 将新的 DIV 添加到页面 打印后再删掉
				let typeName = '';
				if (ths.data.type.indexOf(8) > -1 || ths.data.type.indexOf(9) > -1) {
					typeName += '中餐';
				}
				if (ths.data.type.indexOf(10) > -1 || ths.data.type.indexOf(11) > -1) {
					if (typeName != '') {
						typeName = '、';
					}
					typeName += '晚餐';
				}
				
				let header = document.createElement('div');
				header.style.fontSize = '30px';
				header.fontWeight = 'border';
				header.textalign = 'center';
				header.innerText = ths.data.date + ' ' + typeName + ' 送餐表 ' + (ths.data.addrType == 1 ? '厂内' : '厂外');
				let first = div.firstChild;
				div.insertBefore(header,first);
				
				document.querySelector('body').appendChild(div);
				div.querySelector('table').border = 1;
				let tds = div.querySelectorAll('td');
				for (var i = 0; i < tds.length; i++) {
					tds[i].style.padding = '10px';
				}
				
				printJS({
					printable: printDOMID,
					type: 'html',
					scanStyles: false
				});
				
				div.remove();
			}
		},
		created() {
			let ths = this;
			let begin = new Date();
			let end = new Date();
			end.setMonth(end.getMonth() + 1);
			end = new Date(new Date(end.toDateFormatString('yyyy-MM-01 00:00:00')) - 1000);
			ths.data.daterange = [
				begin.toDateFormatString('yyyy-MM-01 00:00:00'),
				end.toDateFormatString('yyyy-MM-dd 23:59:59')
			];
			ths.baseJS.initPower(ths.power);
			ths.search();
		},
		mounted() {}
	}
</script>

<style scoped>
	.is-current {
		background: #cccccc;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.left {
		float: left;
	}

	.right {
		float: right;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.del-dialog-cnt {
		font-size: 16px;
		text-align: center
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.mr10 {
		margin-right: 10px;
	}

	.m10 {
		margin: 10px;
	}

	.mt1 {
		margin-top: 1px;
	}

	.fr {
		float: right;
	}

	.form-warp {
		position: relative;
		width: 560px;
		height: 520px;
		padding-left: 200px;
		border: 1px solid #ccc;
	}

	.form-warp-left {
		position: absolute;
		left: 0;
		top: 0;
		width: 200px;
		height: 492px;
		padding-top: 28px
	}

	.department-search {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 28px;
		border-bottom: 1px solid #ddd;
		border-right: 1px solid #ddd;
	}

	.department-tree {
		position: relative;
		height: 490px;
		width: 100%;
		border-right: 1px solid #ddd
	}

	.form-warp-main {
		position: relative;
		height: 492px;
		width: 100%;
		padding-top: 28px
	}

	.employee-search {
		position: absolute;
		top: 0;
		left: 1px;
		width: 100%;
		height: 28px;
		border-bottom: 1px solid #ddd
	}

	.list {
		position: relative;
		height: 492px;
		width: 560px
	}

	.card-box {
		position: relative;
		float: left;
		width: 100px;
		height: 60px;
		border: 1px solid #ccc;
		background-color: #fff;
		border-radius: 3px;
		margin: 10px 0 0 10px;
		padding-left: 69px;
		overflow: hidden;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		-khtml-user-select: none;
		user-select: none;
		cursor: pointer
	}

	.card-box.active {
		border: 1px solid #ff5d5b;
		background: url(../../assets/img/selected_red.png) right top no-repeat
	}

	.card-box-img {
		position: absolute;
		left: 0;
		top: 0;
		width: 56px;
		height: 60px;
		line-height: 60px;
		padding-left: 5px;
		background-color: #ebebeb;
		border-right: 1px solid #ccc
	}

	.card-box-img img {
		border-radius: 45px;
		width: 50px;
		height: 50px;
		margin-top: 5px;
	}

	.card-box-content {
		padding: 6px 0
	}

	.card-box-content p {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 0;
		font-size: 10px
	}

	.form-warp-right {
		position: absolute;
		top: 0;
		right: 0;
		height: 492px;
		width: 180px;
		border-left: 1px solid #ddd;
		padding-top: 28px;
		background-color: #fff;
		z-index: 10;
		transition: all 300ms;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.form-warp-right.hide {
		width: 0px;
	}

	.form-warp-right-close {
		position: absolute;
		top: 7px;
		right: 4px;
		width: 12px;
		height: 13px;
		display: block;
		cursor: pointer
	}

	.form-warp-right-close:hover {
		background-position: 0 -12px
	}

	.form-warp-right-title {
		position: absolute;
		top: 0;
		right: 0;
		height: 28px;
		line-height: 27px;
		padding-left: 10px;
		width: 170px;
		border-bottom: 1px solid #ddd;
		cursor: pointer
	}

	.selected-list-warp {
		position: relative;
		height: 492px;
		width: 180px;
	}

	.selected-box {
		position: relative;
		width: 150px;
		height: 55px;
		border: 1px solid #ccc;
		border-radius: 4px;
		margin: auto;
		margin-top: 10px;
		padding: 5px 0 0 10px
	}

	.selected-box p {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 0
	}

	.remove {
		position: absolute;
		top: 2px;
		right: 2px;
		width: 12px;
		height: 13px;
		display: block;
		cursor: pointer;
		opacity: 0.5
	}

	.remove:hover {
		opacity: 1
	}

	.selected-btn {
		position: absolute;
		top: 0;
		right: 1px;
		height: 100%;
		width: 80px;
		line-height: 27px;
		text-align: center;
		border-left: 1px solid #ddd;
		cursor: pointer;
		background-color: #eee;
		color: #666
	}

	.selected-btn:hover {
		color: #333
	}

	.form-control {
		border: 0;
		height: 100%;
	}

	.input-query {
		position: absolute;
		right: 146px;
		top: 5px;
		color: #ccc;
		font-size: 16px;
		cursor: pointer
	}

	.select-all {
		position: absolute;
		top: 0;
		right: 80px;
		height: 100%;
		width: 60px;
		line-height: 27px;
		text-align: center;
		border-left: 1px solid #ddd;
		cursor: pointer;
		background-color: #eee;
		color: #666
	}

	.span-ellipsis {
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		display: block;
	}
</style>
